module.exports = __webpack_public_path__ + "static/110-b9772306e37310c19f01c9bc3b309055.png";